module.exports = __webpack_public_path__ + "img/jquery.b34e848e.png";